import { useState, useEffect } from 'react';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'changeme';

function LoginScreen({ onLogin }) {
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pw === ADMIN_PASSWORD) {
      sessionStorage.setItem('admin_auth', '1');
      onLogin();
    } else {
      setError('Incorrect password.');
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '10rem auto', padding: '0 1.5rem' }}>
      <h2>Admin</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="pw">Password</label>
          <input
            id="pw"
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            autoFocus
          />
        </div>
        {error && <p style={{ color: '#f52e72', marginBottom: '1rem' }}>{error}</p>}
        <button type="submit" className="btn-primary">Enter</button>
      </form>
    </div>
  );
}

function SubmissionDetail({ submission, onClose }) {
  const fieldOrder = [
    'name','email','idea_name','idea_description','problem','who_has_problem','why_you',
    'who_pays','existing_solutions','stage','time_available','biggest_fear','what_you_want',
  ];
  const labels = {
    name: 'Name', email: 'Email', idea_name: 'Idea name', idea_description: 'Idea description',
    problem: 'Problem', who_has_problem: 'Who has the problem', why_you: 'Why you',
    who_pays: 'Who pays & how much', existing_solutions: 'Existing solutions', stage: 'Stage',
    time_available: 'Time available', biggest_fear: 'Biggest fear', what_you_want: 'What they want',
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(229,229,229,0.97)', zIndex: 300, overflowY: 'auto', padding: '3rem' }}>
      <button className="btn-secondary" onClick={onClose} style={{ marginBottom: '2rem' }}>← Back</button>
      <h2 style={{ marginBottom: '0.5rem' }}>{submission.idea_name || '(no title)'}</h2>
      <p style={{ color: '#888', marginBottom: '2rem' }}>
        {submission.email} · submitted {new Date(submission.createdAt).toLocaleDateString()}
        {' · '}
        <span className={`status-badge ${submission.paid ? 'paid' : 'pending'}`}>
          {submission.paid ? 'paid' : 'unpaid'}
        </span>
      </p>
      {fieldOrder.map((key) =>
        submission[key] ? (
          <div className="review-card" key={key}>
            <div className="review-label">{labels[key] || key}</div>
            <div className="review-value">{submission[key]}</div>
          </div>
        ) : null
      )}
    </div>
  );
}

export default function AdminPage() {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem('admin_auth') === '1');
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('paid'); // 'all' | 'paid' | 'unpaid'

  useEffect(() => {
    if (!authed) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/submissions`, {
      headers: { 'x-admin-key': process.env.REACT_APP_ADMIN_KEY || '' },
    })
      .then((r) => r.json())
      .then((data) => { setSubmissions(data.items || []); setLoading(false); })
      .catch(() => { setError('Could not load submissions.'); setLoading(false); });
  }, [authed]);

  if (!authed) return <LoginScreen onLogin={() => setAuthed(true)} />;

  const filtered = submissions.filter((s) =>
    filter === 'all' ? true : filter === 'paid' ? s.paid : !s.paid
  );

  return (
    <div className="admin-container">
      {selected && (
        <SubmissionDetail submission={selected} onClose={() => setSelected(null)} />
      )}

      <h2 style={{ marginBottom: '0.5rem' }}>Nursery submissions</h2>
      <p style={{ color: '#888', marginBottom: '2rem' }}>
        {submissions.filter((s) => s.paid).length} paid ·{' '}
        {submissions.filter((s) => !s.paid).length} unpaid
      </p>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
        {['paid','unpaid','all'].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={filter === f ? 'btn-primary' : 'btn-secondary'}
            style={{ padding: '0.4rem 1rem', fontSize: '9pt' }}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {loading && <p>Loading…</p>}
      {error && <p style={{ color: '#f52e72' }}>{error}</p>}

      {!loading && !error && (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Idea</th>
              <th>Stage</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={6} style={{ color: '#888' }}>No submissions yet.</td></tr>
            )}
            {filtered.map((s) => (
              <tr key={s.id} style={{ cursor: 'pointer' }} onClick={() => setSelected(s)}>
                <td>{s.name}</td>
                <td>{s.email}</td>
                <td>{s.idea_name}</td>
                <td>{s.stage}</td>
                <td>
                  <span className={`status-badge ${s.paid ? 'paid' : 'pending'}`}>
                    {s.paid ? 'paid' : 'unpaid'}
                  </span>
                </td>
                <td>{new Date(s.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
